import { z } from 'zod'

// token-scoped request to permanently close one sandbox pool account on T-Bank's side.
// mirrors preview-sandbox-accounts: the stored connection token is never returned to the
// client, so the caller re-supplies the token that owns the pool.
export const closeSandboxAccountSchema = z.object({
  token: z.string().min(10).max(200),
  tbankAccountId: z.string().min(1),
})
export type CloseSandboxAccountDto = z.infer<typeof closeSandboxAccountSchema>
